export default {
      id: "icon-advertisers-usage",
      viewBox: "0 0 2122 2122",
      url: "/" + "assets/sprite.svg#icon-advertisers",
      toString: function () {
        return this.url;
      }
    }